// extracted by mini-css-extract-plugin
export default {"loadingBox":"index_loadingBox_6oOfI","loadingbanner":"index_loadingbanner_Adnwk","flare":"index_flare_pA9eJ"};